module.exports = __webpack_public_path__ + "img/icon-activity-blue.8e6de118.svg";